import { render, staticRenderFns } from "./Envelope.vue?vue&type=template&id=2f82b63e&scoped=true&"
import script from "./Envelope.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Envelope.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Envelope.vue?vue&type=style&index=0&id=2f82b63e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f82b63e",
  null
  
)

export default component.exports